import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './Tooltip.scss';

/**
 * Custom Tooltip component
 * that renders on the left side
 * any wrapped component
 * */
class Tooltip extends PureComponent {
  static displayName = 'Tooltip';

  static propTypes = {
    target: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    autoShow: PropTypes.bool,
    position: PropTypes.string,
  };

  static defaultProps = {
    autoShow: false,
    position: 'left',
  };

  constructor(props) {
    super(props);
    this.state = {
      showByDefault: props.autoShow,
    };
    this.customRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.showTooltip);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.autoShow !== nextProps.autoShow) {
      this.setState({ showByDefault: nextProps.autoShow });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.autoShow !== this.props.autoShow) {
      this.showTooltip();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.showTooltip);
  }

  showTooltip = () => {
    // auto open the tooltip
    if (this.state.showByDefault) {
      ReactTooltip.show(this.customRef.current);
    }
  };

  /*
   * re-show the tooltip when the mouse leave
   * our custom components.
   * This is need because we are programmatically showing
   * our tooltip based on the showByDefault state.
   *
   * Note. no need for onMouseEnter because the
   * the tooltip is already showned by default
   **/
  handleMouseLeave = () => {
    this.showTooltip();
  };

  render() {
    const { children, position, ...otherProps } = this.props;
    const { target, description } = otherProps;
    const { showByDefault } = this.state;
    const wrappedElement = React.cloneElement(children, otherProps);

    return (
      <div className="tooltip-container">
        {showByDefault ? (
          <span>
            <span
              ref={this.customRef}
              data-tip={description}
              onMouseLeave={this.handleMouseLeave}
            >
              {wrappedElement}
            </span>
            <ReactTooltip
              type="light"
              scrollHide={false}
              place={position}
              effect="solid"
            />
          </span>
        ) : (
          <span>
            {wrappedElement}
            <ReactTooltip
              place={position}
              type="light"
              effect="solid"
              id={target}
            >
              <span className="ToolTip">{description}</span>
            </ReactTooltip>
          </span>
        )}
      </div>
    );
  }
}

export default Tooltip;
